import type { BookTimelineLayout } from "@/lib/timeline/book/BookLayout";
import {
  chapterTickObstacles,
  liftChapterTickPose,
} from "./clearance";
import type { ChapterTickPose } from "./marks";

export function applyChapterTickLabels(
  root: HTMLElement,
  poses: readonly ChapterTickPose[],
  layout: BookTimelineLayout,
  viewportWidth: number,
): void {
  const byId = new Map(poses.map((pose) => [pose.chapterId, pose]));
  for (const el of root.querySelectorAll<HTMLElement>("[data-chapter-tick]")) {
    const base = byId.get(el.dataset.chapterTick ?? "");
    if (base === undefined) {
      el.style.visibility = "hidden";
      continue;
    }
    const pose = liftChapterTickPose(
      base,
      chapterTickObstacles(layout, base.startMs, viewportWidth),
    );
    el.style.visibility = "visible";
    el.style.transform =
      `translate(${pose.x}px, ${pose.y}px) translate(-50%, -100%)`;
  }
}
